export const EDGELESS_TOP_CONTENTEDITABLE_SELECTOR =
  'affine-edgeless-note .edgeless-note-page-content, affine-edgeless-text';
